import { useAppSelector } from 'app/hooks';
import { HourlyData } from 'types/models/ForecastDto';
import { Weather } from 'types/models/Weather';
import {
  convertCToF,
  convertMmToIn,
  convertKphToMph,
  convertMbToInHg,
} from '../../weather/utils/dataConverters';

export const useImperialMeasurements = (
  weatherData: (Weather | HourlyData)[]
) => {
  const useImperial = useAppSelector(
    (state) => state.auth.user?.us_customary_units
  );
  if (!useImperial || !weatherData) return weatherData;
  const convertedWeatherData: (Weather | HourlyData)[] = [];
  if (!weatherData) return weatherData;
  for (const weatherDatum of weatherData) {
    const convertedDatum = {
      ...weatherDatum,
      wind_kph: convertKphToMph(weatherDatum.wind_kph),
      gust_kph: convertKphToMph(weatherDatum.gust_kph),
      temp_c: convertCToF(weatherDatum.temp_c),
      dewpoint_c: convertCToF(weatherDatum.dewpoint_c),
      pressure_mb: convertMbToInHg(weatherDatum.pressure_mb),
      precip_mm: convertMmToIn(weatherDatum.precip_mm),
    };
    convertedWeatherData.push(convertedDatum);
  }
  return convertedWeatherData;
};
